import { Descriptions, Result } from "antd"
import ModalComponent from './modal';
import { exportToCSV } from "./exportExcel";

interface errorsType {
    userID?: number,
    phone?: number | string,
    requestID?: number,
    invoiceNumber?: string,
    nationalID?: string,
    row?: number | string,
    type?: string,
    serviceID?: number | string,
    errors: string[] | string
}

const toErrorList = (errors: string[] | string | undefined): string[] => {
    if (Array.isArray(errors)) return errors.filter(Boolean).map(String)
    if (typeof errors === 'string') return errors.split(',').map((error) => error.trim()).filter(Boolean)
    return []
}

interface Props {
    errors: errorsType[],
    visibleModal: boolean,
    handleCloseModal: any,
    errorMessage?: string
}

const getRowIdentifier = (errorRow: errorsType) =>
    errorRow.phone || errorRow.userID || errorRow.invoiceNumber || errorRow.requestID || errorRow.nationalID || errorRow.row

const getIdentifierKey = (errorRow?: errorsType) => {
    if (!errorRow) return ""
    if (errorRow.phone) return "Phone"
    if (errorRow.invoiceNumber) return "Invoice Number"
    if (errorRow.requestID) return "Request ID"
    if (errorRow.nationalID) return "National ID"
    if (errorRow.row !== undefined && errorRow.row !== null && errorRow.row !== "") return "Row"
    return "User ID"
}

const getIdentifierFields = (errorRow: errorsType) => {
    if (errorRow.userID) return { userID: errorRow.userID }
    if (errorRow.invoiceNumber) return { invoiceNumber: errorRow.invoiceNumber }
    if (errorRow.requestID) return { requestID: errorRow.requestID }
    if (errorRow.nationalID) return { nationalID: errorRow.nationalID }
    if (errorRow.row !== undefined && errorRow.row !== null && errorRow.row !== "") return { row: errorRow.row }
    return { phone: errorRow.phone }
}

export default function BulkErrorsModal(props: Props) {
    const generateErrorsList = (errors: string[]) => {
        return <ul>
            {errors && Array.isArray(errors) && errors.map((error) => <li>{error}</li>)}
        </ul>
    }
    const generateErrorsTable = () => {
        const rows = props.errors && Array.isArray(props.errors) &&
            props.errors.map((errorRow: errorsType) => <Descriptions.Item span={4} label={ getRowIdentifier(errorRow) }>{generateErrorsList(toErrorList(errorRow.errors))}</Descriptions.Item>)
        return <>
            <Result
                status="error"
                style={{ padding: "30px" }}
                title={<p style={{ fontSize: '18px', padding: 0 }}>{props.errorMessage ? props.errorMessage : "Data hasn't been Updated"}</p>}
            />
            <Descriptions bordered>
                <Descriptions.Item span={3} labelStyle={{minWidth: "100px"}} label={<b>{getIdentifierKey(props.errors[0])}</b>}><b>Errors Descriptions</b></Descriptions.Item>
                {rows}
            </Descriptions>
        </>
    }

    const downloadErrorReport = () => {
        if (!props.errors || !Array.isArray(props.errors)) {
            return
        }
        let errors: any[] = []
        for (let index = 0; index < props.errors.length; index++) {
            errors = [
                ...errors,
                ...toErrorList(props.errors[index].errors).map((error) => (
                    {
                        ...getIdentifierFields(props.errors[index]),
                        errors: error
                    }
                ))
            ]
        }
        exportToCSV(errors, "Errors Report")
    }

    return (
        <ModalComponent content={generateErrorsTable()}
            visibleModal={props.visibleModal} handleCloseModal={props.handleCloseModal} handleAcceptModal={downloadErrorReport} cancelText="Close" okText="Download Errors Report" />
    )
}